<script>  
  import Modal from './util/Modal.svelte';

  import GraficoRegioni from './GraficoRegioni.svelte';
  import GraficoNazionale from './GraficoNazionale.svelte';

  export let name;
  let tipoGrafico = 'nazionale';

  console.log('');

  function switchGrafico(event) {
    tipoGrafico = tipoGrafico == 'regionale' ? 'nazionale' : 'regionale';
  }

  function setNazionale(event) {
    tipoGrafico = 'nazionale';
  }

  function setRegionale(event) {
    tipoGrafico = 'regionale';
  }
</script>

<div
  class="mt-4 mx-auto max-w-screen-xl px-4 sm:mt-6 sm:px-6 md:mt-6 lg:mt-8
  lg:px-8 xl:mt-14 min-w-full mb-6">
  <nav
    class="flex items-center flex-wrap p-6 justify-center md:justify-center
    bg-blue-500 rounded-tl-lg rounded-tr-lg"
    id="navigation">
    <div class="flex items-center flex-shrink-0 text-white mr-6 ">
      <img
        src="./italy_flag.svg"
        class="fill-current h-8 w-8 mr-2 "
        width="54"
        height="54"
        alt="logo" />
      <span class="font-semibold text-xl tracking-tight">COVID-19 Italia</span>
      <span class="invisible bg-blue-600" />
    </div>
    <div class="w-full block flex-grow flex items-center lg:w-auto mt-2">
      <div class="text-sm lg:flex-grow">
        <a
          href="#navigation"
          class="mt-4 p-2 rounded lg:inline-block lg:mt-0 text-blue-200
          hover:text-white mr-4 hover:underline uppercase tracking-wide
          font-bold text-center md:text-center transition duration-300
          ease-in-out transform"
          class:text-blue-200={tipoGrafico === 'regionale'}
          class:underline={tipoGrafico === 'nazionale'}
          class:text-white={tipoGrafico === 'nazionale'}
          class:bg-blue-600={tipoGrafico === 'nazionale'}
          on:click|preventDefault={setNazionale}>
          Nazionali
        </a>
        <a
          href="#navigation"
          class="mt-4 p-2 rounded lg:inline-block lg:mt-0 text-blue-200
          hover:text-white hover:underline mr-4 uppercase tracking-wide
          font-bold text-center md:text-center transition duration-300
          ease-in-out transform"
          class:text-blue-200={tipoGrafico === 'nazionale'}
          class:underline={tipoGrafico === 'regionale'}
          class:text-white={tipoGrafico === 'regionale'}
          class:bg-blue-600={tipoGrafico === 'regionale'}
          on:click|preventDefault={setRegionale}>
          Regionali
        </a>
      </div>
    </div>
  </nav>
  <div class="bg-gray-100">
  <Modal>
    {#if tipoGrafico === 'regionale'}
      <GraficoRegioni />
    {:else}
      <GraficoNazionale />
    {/if}
      </Modal>

  </div>
  <footer
    class="w-full text-center border-t border-grey p-4 pin-b bg-blue-500
    rounded-bl-lg rounded-br-lg">
    <p class="font-bold font-sans text-white text-xs">
      <span>
        Powered by
        <a href="http://svelte.dev">Svelte</a>
        |
      </span>
      <span>
        Made with ❤ by
        <a href="https://silvio-giannini.it">Silvio</a>
      </span>
    </p>
  </footer>
</div>
